const PAYLOAD_FIELDS = [
  'legal_business_name',
  'company',
  'cuit',
  'libb',
  'phone_number',
  'email',
  'contact_information',
  'address',
  'postal_code',
  'uuid_district',
  'observations',
];

/**
 * Datos que se envían al backend; `is_provider` e `is_material_provider` los fija el backend.
 * @param {Object} form Estado del formulario.
 * @returns {Object} Payload con los campos del proveedor.
 */
export const buildProviderPayload = (form) =>
  PAYLOAD_FIELDS.reduce((payload, key) => ({ ...payload, [key]: form[key] || null }), {});
